var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        style: _vm.isTabletLandscapeUp
          ? { display: "flex", justifyContent: "space-between" }
          : {},
      },
      [
        _c(
          "div",
          {
            style: {
              width: "100%",
              height:
                _vm.isTabletLandscapeUp && _vm.wrapperHeight
                  ? `${_vm.wrapperHeight}px`
                  : "90vh",
              backgroundImage: _vm.isTabletLandscapeUp
                ? _vm.getCurrentDesktopImage()
                : "",
              backgroundRepeat: _vm.isTabletLandscapeUp ? "no-repeat" : "",
              backgroundSize: _vm.isTabletLandscapeUp ? "cover" : "",
              backgroundPosition: _vm.isTabletLandscapeUp ? "left top" : "",
            },
          },
          [
            _c(
              "Container",
              {
                ref: "formContainer",
                style: {
                  width: _vm.isTabletLandscapeUp ? "50%" : "100%",
                  paddingRight: _vm.isTabletLandscapeUp ? "30px" : "",
                  marginLeft: _vm.isTabletLandscapeUp ? "45%" : "",
                  transform: _vm.isTabletLandscapeUp
                    ? `scale(${_vm.containerScale})`
                    : "",
                  transformOrigin: _vm.isTabletLandscapeUp ? "top right" : "",
                },
              },
              [
                _c("FormRow", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "ChosenButton",
                        {
                          attrs: {
                            chosen:
                              _vm.donationPeriod ===
                              _vm.donationPeriodType.DONATION_PERIOD,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.choseType(
                                _vm.donationPeriodType.DONATION_PERIOD
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.donationPeriodType.DONATION_PERIOD) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "ChosenButton",
                        {
                          attrs: {
                            chosen:
                              _vm.donationPeriod ===
                              _vm.donationPeriodType.DONATION_SINGLE,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.choseType(
                                _vm.donationPeriodType.DONATION_SINGLE
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.donationPeriodType.DONATION_SINGLE) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("br"),
                _c(
                  "Form",
                  [
                    _c(
                      "FormCard",
                      [
                        _c("BreadCrumb", {
                          attrs: { items: _vm.breadCrumbitems },
                        }),
                        _c("FormHeading", [
                          _vm._v(" " + _vm._s(_vm.steps.DONATION_AMOUNT) + " "),
                          _vm.donationAmount
                            ? _c("span", [
                                _vm._v("$ " + _vm._s(_vm.donationAmount)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm.donationPeriod ==
                        _vm.donationPeriodType.DONATION_SINGLE
                          ? _c("FormRow", [
                              _c(
                                "div",
                                { staticClass: "btn-wrap" },
                                [
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "500",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("500")
                                        },
                                      },
                                    },
                                    [_vm._v(" $500 ")]
                                  ),
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "2000",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("2000")
                                        },
                                      },
                                    },
                                    [_vm._v(" $2000 ")]
                                  ),
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "3000",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("3000")
                                        },
                                      },
                                    },
                                    [_vm._v(" $3000 ")]
                                  ),
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "5000",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("5000")
                                        },
                                      },
                                    },
                                    [_vm._v(" $5000 ")]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm.donationPeriod ==
                        _vm.donationPeriodType.DONATION_PERIOD
                          ? _c("FormRow", [
                              _c(
                                "div",
                                { staticClass: "btn-wrap" },
                                [
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "500",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("500")
                                        },
                                      },
                                    },
                                    [_vm._v(" $500 ")]
                                  ),
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "800",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("800")
                                        },
                                      },
                                    },
                                    [_vm._v(" $800 ")]
                                  ),
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "1000",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("1000")
                                        },
                                      },
                                    },
                                    [_vm._v(" $1000 ")]
                                  ),
                                  _c(
                                    "ChosenButton",
                                    {
                                      attrs: {
                                        chosen: _vm.donationAmount == "2000",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.choseAmount("2000")
                                        },
                                      },
                                    },
                                    [_vm._v(" $2000 ")]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "FormRow",
                          [
                            [
                              _c(
                                "FormLabel",
                                { attrs: { for: "donation-amount" } },
                                [_vm._v(" 自行輸入捐款金額 ")]
                              ),
                              _c("TextInput", {
                                attrs: {
                                  id: "donation-amount",
                                  "data-testid": "donation-amount",
                                  placeholder: "請輸入台幣金額",
                                  value: _vm.donationAmount,
                                  error: _vm.donationAmountError,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.donationAmount = $event
                                  },
                                },
                              }),
                            ],
                          ],
                          2
                        ),
                        _vm.donationPeriod ==
                        _vm.donationPeriodType.DONATION_SINGLE
                          ? _c(
                              "FormRow",
                              [
                                [
                                  _c(
                                    "FormLabel",
                                    { attrs: { for: "donation-way" } },
                                    [_vm._v(" 捐款方式 ")]
                                  ),
                                  _c("SelectInput", {
                                    attrs: {
                                      id: "donation-way",
                                      options: [
                                        _vm.donationWayType.ECPAY_SINGLE_CREDIT,
                                        // donationWayType.ECPAY_SINGLE_ATM, // 暫時關閉ATM轉帳繳款因為詐騙原因
                                        _vm.donationWayType.ECPAY_SINGLE_CVS,
                                        _vm.donationWayType.LINEPAY_SINGLE,
                                        _vm.donationWayType.JKOPAY_SINGLE,
                                      ],
                                      value: _vm.donationWay,
                                      error: _vm.donationWayError,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.donationWay = $event
                                      },
                                    },
                                  }),
                                ],
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.donationPeriod ==
                        _vm.donationPeriodType.DONATION_PERIOD
                          ? _c(
                              "FormRow",
                              [
                                [
                                  _c(
                                    "FormLabel",
                                    { attrs: { for: "donation-way" } },
                                    [_vm._v(" 捐款方式 ")]
                                  ),
                                  _c("SelectInput", {
                                    attrs: {
                                      id: "donation-way",
                                      options: [
                                        _vm.donationWayType.ECPAY_PERIOD_CREDIT,
                                        _vm.donationWayType.LINEPAY_PERIOD,
                                      ],
                                      value: _vm.donationWay,
                                      error: _vm.donationWayError,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.donationWay = $event
                                      },
                                    },
                                  }),
                                ],
                                _c(
                                  "p",
                                  { staticStyle: { "font-size": "1.2rem" } },
                                  [
                                    _vm._v(
                                      "提醒您：定期定額將於下個月同一日進行扣款，若需取消定期定額，請來電或寄信至 fin@teach4taiwan.org 與我們聯繫"
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c("br"),
                        _c(
                          "Align",
                          { attrs: { right: "" } },
                          [
                            _c(
                              "Button",
                              {
                                attrs: { small: _vm.isMobile },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.submit()
                                  },
                                },
                              },
                              [_vm._v(" 下一步 ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        !_vm.isTabletLandscapeUp
          ? _c("div", { staticStyle: { width: "100%", marginTop: "300px" } }, [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: {
                  src: _vm.getCurrentMobileImage(),
                  alt: "Sample Image",
                },
              }),
            ])
          : _vm._e(),
      ]
    ),
    _c(
      "h2",
      {
        staticStyle: {
          "font-weight": "bold",
          "margin-bottom": "10px",
          color: "#e72774",
        },
        style: _vm.isTabletLandscapeUp
          ? { fontSize: "30px" }
          : { fontSize: "25px" },
      },
      [_vm._v(" 捐款人分享 ")]
    ),
    _c(
      "div",
      {
        style: _vm.isTabletLandscapeUp
          ? {
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              marginTop: "30px",
              fontSize: "16px",
            }
          : {
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              marginTop: "30px",
              padding: "0 20px",
              fontSize: "14px",
            },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              "background-color": "#eee",
              padding: "20px",
              "border-radius": "5px",
              "box-shadow": "2px 2px 7px rgba(0, 0, 0, 0.3)",
            },
            style: _vm.isTabletLandscapeUp
              ? {
                  flex: 1,
                  maxWidth: "25%",
                }
              : {
                  width: "100%",
                },
          },
          [
            _c(
              "p",
              { staticStyle: { "text-align": "left", "line-height": "1.8" } },
              [
                _vm._v(
                  " 雖然在我成長經驗中，父母無法時常陪伴於身邊，但是我很幸運，都遇到很多很好的老師。 我相信如果孩子可以遇到一個好的老師，就有機會可以翻轉未來，所以這是為什麼我會一直支持 TFT。 "
                ),
              ]
            ),
            _vm._m(0),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              "background-color": "#eee",
              padding: "20px",
              "border-radius": "5px",
              "box-shadow": "2px 2px 7px rgba(0, 0, 0, 0.3)",
            },
            style: _vm.isTabletLandscapeUp
              ? {
                  flex: 1,
                  maxWidth: "25%",
                }
              : {
                  width: "100%",
                },
          },
          [
            _c(
              "p",
              { staticStyle: { "text-align": "left", "line-height": "1.8" } },
              [
                _vm._v(
                  " 我出身於偏鄉，會想要讓偏鄉的小朋友們，能夠更快速、更直接的接觸到這個世界，讓他們知道世界是很廣闊的，原來人生可以那麼豐富、精彩。 期待他們未來在外，累積了視野與知識後，再將經驗與想法回饋家鄉。 "
                ),
              ]
            ),
            _vm._m(1),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              "background-color": "#eee",
              padding: "20px",
              "border-radius": "5px",
              "box-shadow": "2px 2px 7px rgba(0, 0, 0, 0.3)",
            },
            style: _vm.isTabletLandscapeUp
              ? {
                  flex: 1,
                  maxWidth: "25%",
                }
              : {
                  width: "100%",
                },
          },
          [
            _c(
              "p",
              { staticStyle: { "text-align": "left", "line-height": "1.8" } },
              [
                _vm._v(
                  " 我有小孩， 我覺得小孩的教養很重要， 而台灣的教育環境有很多問題， 需要有人去改變， TFT 做的項目很特別、很深， 在做的就是一些很重要的改變。 "
                ),
              ]
            ),
            _vm._m(2),
          ]
        ),
      ]
    ),
    _c(
      "div",
      { style: _vm.isTabletLandscapeUp ? { padding: "70px 100px" } : {} },
      [
        _c(
          "h2",
          {
            staticStyle: {
              "font-weight": "bold",
              "margin-top": "30px",
              "margin-bottom": "10px",
              color: "#e72774",
            },
            style: _vm.isTabletLandscapeUp
              ? { fontSize: "30px" }
              : { fontSize: "25px" },
          },
          [_vm._v(" 資金用途 ")]
        ),
        _c("br"),
        _c(
          "div",
          {
            style: _vm.isTabletLandscapeUp
              ? {
                  display: "flex",
                  justifyContent: "center",
                }
              : {},
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  padding: "20px",
                  "padding-top": "40px",
                  margin: "0 auto",
                  "text-align": "center",
                },
                style: _vm.isTabletLandscapeUp ? { maxWidth: "700px" } : {},
              },
              [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "margin-bottom": "10px",
                    },
                    style: _vm.isTabletLandscapeUp
                      ? { fontSize: "24px" }
                      : { fontSize: "20px" },
                  },
                  [_vm._v(" 將資源忠實地運用，朝願景邁進。 ")]
                ),
                _c("hr", {
                  staticStyle: { margin: "20px auto", width: "40%" },
                }),
                _c(
                  "p",
                  {
                    staticStyle: { "line-height": "1.5" },
                    style: _vm.isTabletLandscapeUp
                      ? { fontSize: "16px" }
                      : { fontSize: "14px" },
                  },
                  [
                    _vm._v(
                      " TFT 為非營利組織，資金收入 100% 來自組織、個人捐贈及其他非以營利為目的之收入。為了穩定營運與發展 TFT 計畫與多元回應議題方案，確保孩子的受教權益，TFT 提前募集所需的資金，確保組織財務的穩健，讓影響力得以發生。 "
                    ),
                  ]
                ),
                _c(
                  "p",
                  {
                    staticStyle: { "line-height": "1.5" },
                    style: _vm.isTabletLandscapeUp
                      ? { fontSize: "16px" }
                      : { fontSize: "14px" },
                  },
                  [
                    _vm._v(
                      " 除了依法規要求之會計年度查核之外，為使大眾能有效理解財務規劃及運用，TFT 額外委任會計師進行學年度查核，並個別出具財務報表，以負責任的方式呈現組織對每一份資源妥善使用。 "
                    ),
                    _c("br"),
                    _c("br"),
                    _c(
                      "a",
                      {
                        staticStyle: { color: "#e73273" },
                        attrs: {
                          href: "https://www.teach4taiwan.org/finance/",
                          target: "_blank",
                        },
                      },
                      [_vm._v(" 了解 TFT 財務報告 ")]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        staticStyle: { "text-align": "center", margin: "auto" },
        style: { width: _vm.isTabletLandscapeUp ? "60%" : "90%" },
      },
      [
        _c(
          "h2",
          {
            staticStyle: {
              "font-weight": "bold",
              "margin-bottom": "10px",
              color: "#e72774",
            },
            style: _vm.isTabletLandscapeUp
              ? { fontSize: "30px" }
              : { fontSize: "25px" },
          },
          [_vm._v(" 捐款相關疑問 ")]
        ),
        _c("br"),
        _c("toggleItem", {
          attrs: {
            title: "除線上捐款，是否還有其他捐款方式？",
            content:
              "有的，除了線上捐款，也可以透過<a style='color: #e73273' href='https://shopee.tw/teach4taiwan' target='_blank'>蝦皮</a>、<a style='color: #e73273' href='https://service.jkopay.com/r/aweb?url=https%3A%2F%2Fdonation-app.jkos.com%2Fcharity-group%2F2' target='_blank'>街口支付</a>、<a style='color: #e73273' href='https://web-tw-pay.line.me/cms/donation/sellers/tft' target='_blank'>LINEPay</a> 與下列方式捐款支持。<br><br>【台幣轉帳】<br>請依下列資訊進行轉帳，並於轉帳完將收據開立資訊（收據抬頭姓名、身分證字號或公司統編、聯絡電話、電子信箱）寄到 fin@teach4taiwan.org。<br>若有紙本收據需求，除上述資訊外，也邀請您一併提供收據寄件地址與收件人資訊。<br><br>戶名｜財團法人為台灣而教教育基金會<br>匯款銀行｜國泰世華銀行忠孝分行 (013)<br>匯款帳戶｜011035009622<br><br>【郵政劃撥】<br>請至郵局索取劃撥單，並詳細填寫捐款人聯絡資料，完成劃撥。<br><br>戶名｜財團法人為台灣而教教育基金會<br>劃撥帳號｜50394835<br><br>【支票匯款】<br>請將支票寄送到 TFT 辦公室，並請於背面註明禁止背書轉讓。<br><br>受款人｜財團法人為台灣而教教育基金會<br>支票寄送地址｜10043 台北市中正區寶慶路 25 號 2 樓 TFT 財務收",
          },
        }),
        _c("toggleItem", {
          attrs: {
            title: "是否有外幣、國外捐款管道？",
            content:
              "【非台幣轉帳】<br>請用以下資訊進行轉帳：<br><br>Beneficiary’s Name｜TEACH FOR TAIWAN<br>A/C with Bank｜CATHAY UNITED BANK, TAIPEI, TAIWAN（國泰世華商業銀行）<br>7 SONGREN ROAD, XINYI DISTRICT, TAIPEI, TAIWAN（台北市信義區松仁路7號）<br>Account No.｜011087069003<br>Swift Code｜UWCBTWTP<br>Beneficiary’s Telephone No.｜+886 (02)-2345-6225<br>Email Address｜fin@teach4taiwan.org<br><br>【美國收據】<br>透過「世台聯合基金會(STUF UnitedFundInc.)」捐款，世台為在美國登記成立之非營利慈善機構，為美國聯邦政府核可之 501(c)(3) 組織。由世台基金會開立的捐贈收據，在美國可依法扣抵聯邦所得稅。<br><br>透過「世台聯合基金會(STUF UnitedFundInc.)」捐款——支票<br>請列印填寫 「Pledge Form」，完成填寫此表後，連同支票寄給「世台聯合基金會」。<br>支票抬頭｜STUF United Fund Inc.<br>支票備註｜支票中須備註指名捐贈 Donor-designated fund – Teach For Taiwan<br>郵寄地址｜STUF United Fund P.O. Box 520511 Flushing, NY 11352<br><br>透過「世台聯合基金會(STUF UnitedFundInc.)」捐款——匯款<br>捐款者若以匯款的方式捐贈，請先行聯繫世台基金會 黃怡妙 總幹事，世台基金會將提供詳細匯款資訊給您。捐款時請指名捐贈「Donor-designated fund – Teach For Taiwan」。<br><br>黃總幹事（Yi-Miao Huang）聯絡資訊：<br>Tel｜914-433-0415<br>Email｜yimiao@stufunited.org",
          },
        }),
        _c("toggleItem", {
          attrs: {
            title: "如何知道當次捐款有沒有成功？",
            content:
              "若捐款成功，捐款系統將顯示「捐款成功」畫面。<br>如有任何問題歡迎寄電子郵件至 fin@teach4taiwan.org 詢問。",
          },
        }),
        _c("toggleItem", {
          attrs: {
            title: "完成捐款後，想調整捐款金額、更換信用卡或停止捐款怎麼辦？",
            content:
              "如有以下需求：<br>・修改定期定額捐款資料（更改信用卡卡號、調整捐款金額、暫停捐款）<br>・沒收到或需要提早取得年度紙本收據（通常於每年 4 月底前寄出）<br><br>請寄電子郵件至 fin@teach4taiwan.org，說明您的需求並提供以下資訊，供我們確認查詢您的紀錄：<br>・捐款姓名<br>・聯絡資訊（手機、Email、收據寄送地址）<br>・捐款方式（線上捐款、郵政劃撥、每月定期定額、匯款：請提供匯款帳號末五碼）<br>・捐款金額",
          },
        }),
        _c("toggleItem", {
          attrs: {
            title: "捐款給 TFT 是否可以抵稅？",
            content:
              "可以，您的捐款可在下一年度綜所稅報稅時列舉扣除。<br><br>TFT 已向國稅局申請「捐贈扣除額單據電子化」，因此只要您捐款時確實填寫「身分證字號」，申報列舉扣除時將不需要再檢附紙本贊助收據；您也可選擇以紙本實體收據申報，定期定額捐款則以年度收據的方式開立，並於每年二月結算後寄出。<br><br>若您是透過非 TFT 官網平台捐款（例如：蝦皮、街口、linepay、郵政劃撥等），並且選擇單筆紙本收據，財務會在 隔月的 20 號前完成寄出。例如：捐款人於 10 月捐款，財務會於 11/20 前掛號寄出單筆紙本收據予捐款人",
          },
        }),
        _c("toggleItem", {
          attrs: {
            title: "若是代表企業/基金會，想捐款支持或合作，可以如何接洽？",
            content:
              "邀請您前往 <a style='color: #e73273' href='https://www.teach4taiwan.org/about/sponsor_partner/' target='_blank'>成為企業 / 基金會支持夥伴</a> 頁面了解更多。",
          },
        }),
        _c("toggleItem", {
          attrs: {
            title:
              "我已是 TFT 捐款者，需要查詢捐款紀錄、重新申請電子收據，可以如何處理？",
            content:
              "若需重新索取電子收據，可登入「<a style='color: #e73273' href='https://donation.teach4taiwan.org/search' target='_blank'>TFT 捐款紀錄查詢</a>」申請補發。",
          },
        }),
      ],
      1
    ),
    _c("div", [
      _c("br"),
      _c(
        "h2",
        {
          staticStyle: {
            "font-weight": "bold",
            "margin-bottom": "10px",
            color: "#e72774",
          },
          style: _vm.isTabletLandscapeUp
            ? { fontSize: "30px" }
            : { fontSize: "25px" },
        },
        [_vm._v(" 了解更多 ")]
      ),
      _c("br"),
      _c(
        "div",
        {
          style: _vm.isTabletLandscapeUp
            ? {
                display: "flex",
                justifyContent: "space-between",
                width: "63%",
                margin: "auto",
                marginBottom: "40px",
              }
            : { marginBottom: "40px" },
        },
        [
          _c("div", { staticStyle: { padding: "10px" } }, [
            _c(
              "a",
              {
                staticStyle: { "text-decoration": "none", cursor: "pointer" },
                attrs: {
                  href: "https://www.teach4taiwan.org/about/sponsor_partner/",
                  target: "_blank",
                },
              },
              [
                _c(
                  "div",
                  {
                    style: {
                      width: _vm.isTabletLandscapeUp ? "250px" : "80%",
                      margin: "auto",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        src: require("@/images/bottom1.jpg"),
                        alt: "企業合作",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "background-color": "#e73273",
                          "font-size": "20px",
                          color: "white",
                        },
                      },
                      [_vm._v("企業合作 ➔")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c("div", { staticStyle: { padding: "10px" } }, [
            _c(
              "a",
              {
                staticStyle: { "text-decoration": "none", cursor: "pointer" },
                attrs: {
                  href: "https://www.teach4taiwan.org/challenge/stories/",
                  target: "_blank",
                },
              },
              [
                _c(
                  "div",
                  {
                    style: {
                      width: _vm.isTabletLandscapeUp ? "250px" : "80%",
                      margin: "auto",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        src: require("@/images/bottom2.jpg"),
                        alt: "TFT 故事棧",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "background-color": "#e73273",
                          "font-size": "20px",
                          color: "white",
                        },
                      },
                      [_vm._v("TFT 故事棧 ➔")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c("div", { staticStyle: { padding: "10px" } }, [
            _c(
              "a",
              {
                staticStyle: { "text-decoration": "none", cursor: "pointer" },
                attrs: {
                  href: "https://www.teach4taiwan.org/about/",
                  target: "_blank",
                },
              },
              [
                _c(
                  "div",
                  {
                    style: {
                      width: _vm.isTabletLandscapeUp ? "250px" : "80%",
                      margin: "auto",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        src: require("@/images/bottom3.jpg"),
                        alt: "關於我們",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "background-color": "#e73273",
                          "font-size": "20px",
                          color: "white",
                        },
                      },
                      [_vm._v("關於我們 ➔")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticStyle: { "text-align": "right", "line-height": "30px" } },
      [
        _c("img", {
          staticStyle: {
            width: "25px",
            height: "25px",
            "vertical-align": "text-bottom",
          },
          attrs: { src: require("@/images/icons/cheng_icon.png") },
        }),
        _vm._v(" 張小姐，屏東人 "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticStyle: { "text-align": "right", "line-height": "30px" } },
      [
        _c("img", {
          staticStyle: {
            width: "25px",
            height: "25px",
            "vertical-align": "text-bottom",
          },
          attrs: { src: require("@/images/icons/xu_icon.png") },
        }),
        _vm._v(" 徐先生，苗栗人 "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticStyle: { "text-align": "right", "line-height": "30px" } },
      [
        _c("img", {
          staticStyle: {
            width: "25px",
            height: "25px",
            "vertical-align": "text-bottom",
          },
          attrs: { src: require("@/images/icons/lee_icon.png") },
        }),
        _vm._v(" 李先生，台北人 "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }